import * as React from 'react';

import styled from 'styled-components';
import { resolvePathFromContentReference, useServicesContext } from '@oneaudi/vtp-shared';

// @ts-ignore
import warrantyNap from '../assets/nap.png';
// @ts-ignore
import warrantyPlus from '../assets/GW-plus.svg';
// @ts-ignore
import warranty5Years from '../assets/GW-plus_Garantie.svg';
import { useI18n } from '@oneaudi/i18n-context';

interface WarrantyImgProps {
  type: string;
}

const WarrantyPlus = styled.div`
  display: inline-block;
  height: 20px;
  width: 60px;
`;

const WarrantyPlusExternal = styled.div`
  display: inline-flex;
  align-items: center;
  height: 20px;
  width: 100px;
`;

const Warranty5Years = styled.div`
  display: inline-block;
  height: 90px;
  width: 68px;
`;

const WarrantyNAP = styled.div`
  display: inline-block;
  height: 35px;
  width: 95px;
`;

const WarrantyImg: React.FC<WarrantyImgProps> = ({ type }) => {
  const { getConfiguration } = useServicesContext();
  const vtpConfiguration = getConfiguration();
  let warrantyPlusLogoUrl = vtpConfiguration?.assets?.warrantyPlusLogo
    ? resolvePathFromContentReference(vtpConfiguration?.assets?.warrantyPlusLogo)
    : vtpConfiguration?.urls?.warrantyPlusLogoURL;
  const hasExternalLogo = warrantyPlusLogoUrl && warrantyPlusLogoUrl !== '';
  const getAltText = (warrantyType: string): string => {
    return useI18n({ id: `nemo.ui.sc.warranty.${warrantyType}.alt.text`, defaultMessage: '' });
  };

  if (warrantyPlusLogoUrl) {
    warrantyPlusLogoUrl += warrantyPlusLogoUrl.includes('?')
      ? '&fmt=webp-alpha'
      : '?fmt=webp-alpha';
  }

  return (
    <>
      {type === 'WarrantyTypeNap' && (
        <WarrantyNAP>
          <img
            src={warrantyNap}
            width="95"
            height="35"
            alt={getAltText(type)}
            data-testid="warrantyNAP"
          />
        </WarrantyNAP>
      )}
      {type === 'WarrantyTypePlus' && hasExternalLogo && (
        <WarrantyPlusExternal data-testid="warranty-plus-logo-external">
          <img src={warrantyPlusLogoUrl} width="100%" height="auto" alt={getAltText(type)} />
        </WarrantyPlusExternal>
      )}
      {type === 'WarrantyTypePlus' && !hasExternalLogo && (
        <WarrantyPlus data-testid="warranty-plus-logo">
          <img src={warrantyPlus} width="60" height="20" alt={getAltText(type)} />
        </WarrantyPlus>
      )}
      {(type === 'WarrantyType5Years' || type === 'WarrantyTypeAsgExtended') && (
        <Warranty5Years>
          <img
            src={warranty5Years}
            width="68"
            height="90"
            alt={getAltText(type)}
            data-testid="warrantyExtended"
          />
        </Warranty5Years>
      )}
    </>
  );
};

export default WarrantyImg;
